module.exports = "<li class=\"video-line\">\r\n    <a href=\"javascript: void\" data-bind=\"name\"></a>\r\n    <span data-bind=\"duration\" class=\"duration\"></span>\r\n</li>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/video/videoLineView.html
 ** module id = 22
 ** module chunks = 0
 **/